import { Transition } from '@uirouter/core';
import { ISCEService, IScope, ITimeoutService } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import UtilService from '../../common/services/util.service';
import { CardDeleteAction } from './card-delete-dialog.action';
import { PaymentMethod } from '../services/payment-method.model';
import { PaycellService } from '../services/paycell.service';
import GoogleAnalyticsService from '../../common/services/analytics/google-analytics.service';
import { DeleteCreditCardEvent } from '../../common/services/analytics/events/dimensions';

/* @ngInject */
export default class CardDeleteDialogController implements ActionHandler {
  private dialogElement;

  protected card: PaymentMethod;
  protected onDeleteSuccess: (paymentMethodID, cardId) => any;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private $state,
    private $scope: IScope,
    private $timeout: ITimeoutService,
    private paycellService: PaycellService,
    private googleAnalytics: GoogleAnalyticsService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#card-delete-dialog').remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof CardDeleteAction) {
      this.card = action.card;
      this.onDeleteSuccess = action.onDeleteSuccess;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
  }

  public onDelete() {
    this.paycellService
      .deletePayment(this.card.paymentMethodID, this.card.cardId)
      .then(() => {
        this.close();
        this.onDeleteSuccess(this.card.paymentMethodID, this.card.cardId);
        const event = angular.extend(JSON.parse(JSON.stringify(new DeleteCreditCardEvent)), { userPackage: localStorage.getItem('activePackages') });
        this.googleAnalytics.trackEvent(event);
      })
      .catch((error) => {
        this.close();
        const event = angular.extend(JSON.parse(JSON.stringify(new DeleteCreditCardEvent)), { userPackage: localStorage.getItem('activePackages'), eventLabel: 'Failure', errorType: error.message || 'An error occured' });
        this.googleAnalytics.trackEvent(event);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/card-delete-dialog/card-delete-dialog.controller.ts